import { render, staticRenderFns } from "./LocationSearchPage.vue?vue&type=template&id=6b04a3c5&scoped=true&"
import script from "./LocationSearchPage.vue?vue&type=script&lang=js&"
export * from "./LocationSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04a3c5",
  null
  
)

export default component.exports